import React from 'react'
import Divider from 'material-ui/Divider'
import ActionHome from 'material-ui/svg-icons/action/home';
import ActionLock from 'material-ui/svg-icons/action/lock';
import LogoutIcon from 'material-ui/svg-icons/action/exit-to-app';
import SupervisorAccount from 'material-ui/svg-icons/action/supervisor-account';
import {List, ListItem} from 'material-ui/List';
import no_avatar from '../images/no_avatar.jpg'
import CircularProgress from 'material-ui/CircularProgress';
import {browserHistory} from 'react-router'
import CheveronRight from 'material-ui/svg-icons/navigation/chevron-right';
import config from '../config'
import ReactGA from 'react-ga'

function toSnake(s){
   return s.replace(/\s/g, "_").toLowerCase()
}


function NavLink( {name, path, location, rightIcon} ) {
    const routePath = (location && location.pathname) || ""

    const select = routePath === path || (routePath === "/" && name === "Latest Payslip")

    return <ListItem id={`nav_${toSnake(name)}`}
                     onClick={() => browserHistory.push(path)}
                     primaryText={select ? <strong className="nav_selected">{name}</strong> : name}
                     rightIcon={rightIcon ? rightIcon : <CheveronRight/>} />
}


export default class extends React.Component {



    home(){
        ReactGA.event({ category: 'Navigation', action: 'Nav Icon Click', label: "Home"});
        window.location.href=config.landing_page_url
    }

    userInfo(){
        const payslip = this.props.latest_payslip;
        const department = (payslip.colleague_data && payslip.colleague_data.department) || <br/>;
        const current_user = this.props.current_user;

        if(!current_user.ready){
            return (
                <div className="spinner flex layout-column layout-align-center-center">
                    <CircularProgress size={50} thickness={5} />
                </div>
            )
        }
        if(current_user.treat_as_error){
            return (
                <div className="flex layout-column layout-align-center-center">
                    Error retrieving your details
                </div>
            )
        }
        return (
            <div>
                <div className="text-large">
                    {current_user.first_name} {current_user.last_name}
                </div>
                <div className="text-small">{current_user.employee_id}</div>

                {current_user.store_name ?
                    <div className="text-small">{current_user.store_name} ({current_user.store_id})</div>
                    : null
                }

                {current_user.role ?
                    <div className="text-small">{current_user.role}</div>
                    : null
                }

                {department ?
                    <div className="text-small">{department}</div>
                    : null
                }
            </div>
        )

    }

    navLink( name, path ) {
        const routePath = (this.props.routing && this.props.routing.locationBeforeTransitions.pathname) || ""
        return <ListItem onClick={() => browserHistory.push(path)}
                         primaryText={routePath === path ? <strong>{name}</strong> : {name}}
                         rightIcon={<CheveronRight/>} />
    }

    logout() {
        ReactGA.event({ category: 'Navigation', action: 'Nav Icon Click', label: "Sign Out"})
        window.location = "https://accounts.google.com/logout"
    }

    render() {

        const current_user = this.props.current_user;
        return (
            <div id="navbar" className="flex layout-column scrollable">
                <div className="padding user-info" >
                    <div className="layout-row layout-align-start-center" >
                        <img className="avatar"
                             ref="avatar"
                             src={current_user.avatar_url ? current_user.avatar_url : no_avatar}
                             alt="User profile"
                             onError={() => this.refs.avatar.src = no_avatar} />
                        <div className="padding"></div>
                        {this.userInfo()}
                    </div>
                </div>
                <Divider/>
                <List>
                    <NavLink name="Latest Payslip" path="/latest-payslip" location={this.props.location}/>
                    <NavLink name="All Payslips" path="/payslips" location={this.props.location}/>
                </List>
                <Divider/>
                <List>
                    { current_user.is_admin ? <NavLink name="Manage Users" path="/manage-users" location={this.props.location} rightIcon={<SupervisorAccount/>}/> : null }
                    <NavLink name="Reset PIN" path="/reset-pin" location={this.props.location} rightIcon={<ActionLock/>}/>
                    <ListItem onClick={() => this.home()} primaryText="Home" rightIcon={<ActionHome/>} />
                    <ListItem id="nav_sign_out" onClick={() => this.logout()} primaryText="Sign Out" rightIcon={<LogoutIcon/>} />
                </List>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nav.js